/**
 * created by mgg  2021/11/02
 *媒体总览(新）
 */
import React from 'react';
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import CustomTable, {TitleIcon} from "../../../components/customTable/CustomTable";
import Title from "../../../components/title/Title";
import * as Action from '../../actions/horizontalManagement'
import * as utils from "../../../../utils";
import {Scrollbars} from "react-custom-scrollbars";
import WeChatReview from "../../../components/weChatReview/WeChatReview";
import MicroBlogReview from "../../../components/microBlogReview/MicroBlogReview";
import TiktokReview from "../../../components/tiktokReview/TiktokReview";
import eventProxy from "../../../../utils/eventProxy";
import more from './images/more.png';
import {getAllNewMediaList} from "../../actions/newMediaManage";
import BaseComponent from "../../../../base/BaseComponent";
import moreImg from "../../../desktop/components/commImg/diandiandian.png";

export default class NewMediaOverview extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Action;
        this.state = {
            registered: "0",  //已备案
            recentActive: "0", //近期活跃
            checking: "0", //审核中
            increased: "0", //新增
            update: "0", //更新
            logout: "0", //注销
            delete: "0", //删除
            newArticle: [], //最新文章
            systemSensitiveList: [], //危险内容
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        let params = {
            pageNum: 1,
            pageSize: 10,
            statusType: 0
        }
        if (this.permissionCheck("pms:accountManage:all")) {

        } else if (this.permissionCheck("pms:accountManage:dept")) {
            params.createUserDeptIds = [window.top.currentUser.defaultInfo.dept.id];  //部门权限
        } else {
            params.createBy = window.top.currentUser.id;  //个人权限
        }
        getAllNewMediaList(params, (data) => {
            let mediaCodes = ["default"];
            data && data.length > 0 && data.forEach(item => {
                mediaCodes.push(item.code);
            })
            this.activeAccountNum(mediaCodes);
            this.mediaStatusNum(mediaCodes);
            this.getqueryLatestMaterial(mediaCodes);//获取最新文章
            this.getSystemSensitiveCheckListQuery(mediaCodes);//获取危险内容
        })
        //事件监听
        // window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
        window.location.reload();   //重新加载页面，类似f5刷新
    }

    componentWillUnmount() {
        // 一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
        // window.removeEventListener('resize', this.resize);
    }

    render() {
        let autoMaxHeight = "calc(100vh - 300px - (100vh - 300px) / 2)";
        let scrollHeight = document.body.scrollHeight;
        if(scrollHeight < 852 || (window.screen.height >= 768 && window.screen.height < 1080)){
            autoMaxHeight = "calc(100vh - 374px - (100vh - 374px) / 2)";
        }
        return (
            <div style={{margin: 15}}>
                {this.renderRecord()}
                {/*<Scrollbars autoHeight autoHide autoHeightMax={"calc(100vh - 208px)"} style={{borderRadius: "5px"}}>*/}
                    {this.renderNewArticle(autoMaxHeight)}
                    {this.renderDangerContent(autoMaxHeight)}
                {/*</Scrollbars>*/}
                {/*// 微信预览*/}
                <WeChatReview ref={(WeChatReview) => {
                    this.WeChatReview = WeChatReview
                }}/>
                {/*微博预览*/}
                <MicroBlogReview ref={(MicroBlogReview) => {
                    this.MicroBlogReview = MicroBlogReview
                }}/>
                {/*抖音预览*/}
                <TiktokReview ref={(TiktokReview) => {
                    this.TiktokReview = TiktokReview
                }}/>
            </div>
        )
    }

    //渲染备案类型
    renderRecord() {
        return (
            <div style={{display: 'flex', flexWrap: "wrap", marginBottom: 15, justifyContent: "space-between"}}>
                <div style={{
                    display: "flex",
                    width: 405,
                    height: 84,
                    background: "linear-gradient(180deg, #37D99F 0%, #28BC88 100%)",
                    borderRadius: "5px",
                    marginRight: 8,
                    opacity: 1,
                    color: "#fff"
                }}>
                    <div style={{width: 240, display: "flex", alignItems: "center", cursor: "pointer"}} onClick={() => {
                        window.location.hash = '/view/newMediaMatrix/pms/newMediaMatrix/mediaManagement';
                    }}>
                        <div style={{marginLeft: 40}}><img alt={""} src='images/beian.png'/></div>
                        <div style={{marginLeft: 30, fontSize: "14px"}}>已备案</div>
                        <div style={{marginLeft: 30, fontSize: "20px"}}>{this.state.registered}</div>
                    </div>
                    <div style={{width: 1, height: 60, background: "#fff", opacity: 0.4, margin: "11px auto"}}/>
                    <div style={{width: 163, display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: 20,}}><img alt={""} src='images/fire.png'/></div>
                        <div style={{marginLeft: 10, fontSize: "12px", opacity: 1}}>近期活跃</div>
                        <div style={{marginLeft: 15, fontSize: "16px", opacity: 1}}>{this.state.recentActive}</div>
                    </div>
                </div>
                <div style={{
                    display: "flex",
                    width: 947,
                    height: 84,
                    background: "linear-gradient(180deg, #58B0FB 0%, #3F99F3 100%)",
                    borderRadius: "5px",
                    opacity: 1,
                    color: "#fff"
                }}>
                    <div style={{width: 250, display: "flex", alignItems: "center"}} onClick={() => {
                        this.auditing()
                    }}>
                        <div style={{marginLeft: 45}}><img alt={""} src='images/shenhe.png'/></div>
                        <div style={{marginLeft: 30, fontSize: "14px", cursor: "pointer"}}>审核中</div>
                        <div style={{marginLeft: 30, fontSize: "20px"}}>{this.state.checking}</div>
                    </div>
                    <div style={{width: 1, height: 60, background: "#fff", opacity: 0.4, margin: "11px auto"}}/>
                    <div style={{width: 170, display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: 45,}}><img alt={""} src='images/add1.png'/></div>
                        <div style={{marginLeft: 4, fontSize: "12px", opacity: 1}}>新增</div>
                        <div style={{marginLeft: 15, fontSize: "16px", opacity: 1}}>{this.state.increased}</div>
                    </div>
                    <div style={{
                        width: 1,
                        height: 24,
                        background: "#fff",
                        opacity: 0.4,
                        margin: "30px auto",
                        borderRadius: "5px",
                    }}/>
                    <div style={{width: 170, display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: 45,}}><img alt={""} src='images/update.png'/></div>
                        <div style={{marginLeft: 4, fontSize: "12px", opacity: 1}}>更新</div>
                        <div style={{marginLeft: 15, fontSize: "16px", opacity: 1}}>{this.state.update}</div>
                    </div>
                    <div style={{
                        width: 1,
                        height: 24,
                        background: "#fff",
                        opacity: 0.4,
                        margin: "30px auto",
                        borderRadius: "5px",
                    }}/>
                    <div style={{width: 170, display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: 45,}}><img alt={""} src='images/logout.png'/></div>
                        <div style={{marginLeft: 4, fontSize: "12px", opacity: 1}}>注销</div>
                        <div style={{marginLeft: 15, fontSize: "16px", opacity: 1}}>{this.state.logout}</div>
                    </div>
                    <div style={{
                        width: 1,
                        height: 24,
                        background: "#fff",
                        opacity: 0.4,
                        margin: "30px auto",
                        borderRadius: "5px",
                    }}/>
                    <div style={{width: 170, display: "flex", alignItems: "center"}}>
                        <div style={{marginLeft: 45,}}><img style={{width: 18, height: 18}} alt={""}
                                                            src='images/del_new.png'/></div>
                        <div style={{marginLeft: 4, fontSize: "12px", opacity: 1}}>删除</div>
                        <div style={{marginLeft: 15, fontSize: "16px", opacity: 1}}>{this.state.delete}</div>
                    </div>
                </div>
            </div>
        )
    }

    auditing() {
        window.location.hash = '/view/newMediaMatrix/pms/newMediaMatrix/mediaManagement';
        setTimeout(() => {
            eventProxy.trigger('auditing');
        }, 1);
    }

    //渲染最新文章
    renderNewArticle(autoMaxHeight) {
        let titleKeyList = [
            {
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                width: 60,
            }, {
                key: 'title',
                titleName: '标题',
                ellipsis: true,
                align: 'left',
                render: (text, record, index) => {
                    return (
                        <div onClick={() => this.itemClick(record)}>
                            <div style={{position: 'relative',}}>
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold', cursor: 'pointer'
                                }}
                                     title={record.title}>{record.mediaType === 5 ? (record.title ? record.title : '未命名的标题') : record.title}</div>
                            </div>
                        </div>

                    )
                }
            },
            {
                key: 'publishDate',
                titleName: '发布时间',
                ellipsis: true,
                width: 160,
                render: (text, record, index) => {
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            {record.publishDate ? utils.formatDate(record.publishDate) : ''}
                        </div>
                    )
                }
            },
            {
                key: 'mediaAccountName',
                titleName: '账号名称',
                ellipsis: true,
                width: 170,
                render: (text, record) => {
                    let mediaName = record.mediaAccountName;
                    let showText;
                    if (record && mediaName && mediaName.indexOf("[") > -1 && mediaName.indexOf("]") > -1) {
                        let status = mediaName.substring(mediaName.indexOf("[") + 1, mediaName.indexOf("]"));
                        let index = mediaName.lastIndexOf("[");
                        let content = mediaName.slice(0, index);
                        showText = (<span>{content}[<span style={{color: "red"}}>{status}</span>]</span>)
                    } else {
                        showText = mediaName;
                    }
                    return (<div
                        style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{showText}</div>)
                }
            },
            {
                titleName: '媒体类型',
                width: 100,
                render: (text, record, index) => {
                    let iconType = '';
                    let title = '';
                    if (record.mediaType === 2) {
                        iconType = 'weChat';
                        title = "公众号"
                    } else if (record.mediaType === 3) {
                        iconType = 'microBlog'
                        title = "微博"
                    } else if (record.mediaType === 5) {
                        iconType = 'tiktok'
                        title = "抖音"
                    }
                    return (<div>
                            <TitleIcon title={title} iconType={iconType}/>
                        </div>

                    )
                }
            },
            {
                key: 'readNum',
                titleName: '阅读（转评赞）',
                ellipsis: true,
                width: 130,
            },
            {
                key: 'deptName',
                titleName: '主责单位',
                ellipsis: true,
                width: 130,
                render: (text, record, index) => {
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            {record.deptName ? record.deptName : '未知'}
                        </div>
                    )
                }
            }
        ];
        return (
            <div style={{backgroundColor: "#fff", borderRadius: 5}}>
                <div style={{
                    height: 43,
                    lineHeight: '60px',
                    background: 'white',
                    width: '100%',
                    float: 'left',
                    borderRadius: "5px 5px 0px 0px"
                }}>
                    <div style={{fontSize: 16, paddingLeft: 20, float: 'left', fontWeight: 400}}>最新文章</div>
                    <div style={{
                            fontSize: 13,
                            right: 0,
                            color: 'rgba(0, 0, 0, 0.45)',
                            float: 'right',
                            marginRight: 26,
                            cursor: 'pointer'
                        }} onClick={() => this.newArticleMore()}><span
                            style={{verticalAlign: "middle"}}>查看更多</span>
                            <span><img style={{display: "inline-block", width: 10, height: 10, objectFit: "cover"}}
                                       alt={""} src={more}/></span>
                    </div>
                </div>
                <div style={{clear: 'both'}}/>
                <Scrollbars autoHide autoHeight autoHeightMax={autoMaxHeight} style={{borderRadius: "5px"}}>
                    <CustomTable
                        // defineStyle={{padding: "0px 20px"}}
                        dataSource={this.state.newArticle}
                        titleKeyList={titleKeyList}
                        pagination={false}
                        onRow={record => {
                            return {
                                onClick: event => {
                                }, // 点击行
                            };
                        }}
                        style={{border: "none"}}
                    />
                </Scrollbars>
            </div>
        )
    }


    //渲染危险内容
    renderDangerContent(autoMaxHeight) {
        let titleKeyList =
            [{
                key: 'key',
                titleName: '序号',
                ellipsis: true,
                align: 'left',
                width: 60
            }, {
                key: 'title',
                titleName: '文章标题',
                ellipsis: true,
                align: 'left',
                render: (text, record, index) => {
                    return (
                        <div onClick={() => {
                            this.itemDangerClick(record)
                        }}>
                            <div>
                                <div style={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 'bold',  cursor: 'pointer'
                                }}
                                     title={record.title}>{record.title}</div>
                            </div>

                        </div>

                    )
                }
            },
                {
                    key: 'mediaName',
                    titleName: '所属媒体',
                    ellipsis: true,
                    align: 'left',
                    width: 120,
                },
                {
                    key: 'deptName',
                    titleName: '主责单位',
                    ellipsis: true,
                    align: 'left',
                    width: 120,
                },
                {
                    key: 'look',
                    titleName: '敏感词',
                    align: 'left',
                    width: 120,
                    render: (text, record, index) => {
                        let sensitiveWord = '';
                        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
                            sensitiveWord = sensitiveWord + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
                        });
                        return (
                            <div title={sensitiveWord} style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {sensitiveWord}
                            </div>
                        )
                    }
                },
                {
                    key: 'account',
                    titleName: '账号',
                    ellipsis: true,
                    align: 'left',
                    width: 140,
                },
                {
                    key: 'checkTime',
                    titleName: '监测时间',
                    align: 'left',
                    width: 160,
                    render: (text, record, index) => {
                        return (
                            <div style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}>
                                {record.checkTime ? utils.formatDate(record.checkTime) : ""}
                            </div>
                        )
                    }
                }];
        return (
            <div style={{marginTop: 15, backgroundColor: "#fff", borderRadius: 5}}>
                <div style={{background: 'white', borderRadius: "5px 5px 0px 0px"}}>
                    <div style={{
                        height: 43,
                        lineHeight: '60px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                        borderRadius: "5px 5px 0px 0px"
                    }}>
                        <div style={{fontSize: 16, paddingLeft: 20, float: 'left', fontWeight: 400}}>危险内容提醒</div>
                        {
                            this.permissionCheck("security_management") ? <div style={{
                                fontSize: 13,
                                right: 0,
                                color: 'rgba(0, 0, 0, 0.45)',
                                float: 'right',
                                marginRight: 26,
                                cursor: 'pointer'
                            }} onClick={() => this.dangerContentMored()}><span
                                style={{verticalAlign: "middle"}}>查看更多</span>
                                <span><img style={{display: "inline-block", width: 10, height: 10, objectFit: "cover"}}
                                           alt={""} src={more}/></span>
                            </div> : null
                        }
                    </div>
                    <div style={{clear: 'both'}}/>
                </div>
                <Scrollbars autoHide autoHeight autoHeightMax={autoMaxHeight} style={{borderRadius: "5px"}}>
                    <CustomTable
                        dataSource={this.state.systemSensitiveList}
                        titleKeyList={titleKeyList}
                        pagination={false}
                        onRow={record => {
                            return {
                                onClick: event => {
                                    //    console.log('点击了最新文章的一行')
                                }, // 点击行
                            };
                        }}
                    />
                </Scrollbars>
            </div>
        )
    }

    // 获取各媒体活跃数
    activeAccountNum(mediaCodes) {
        let params = {};
        params.mediaCodes = mediaCodes;
        this.Actions.activeAccountNum(params, (data) => {
            if (data) {
                this.setState({
                    recentActive: data.totalActiveNum,
                })
            }
        })
    }

    // 获取各媒体各状态数
    mediaStatusNum(mediaCodes) {
        let params = {};
        if (this.permissionCheck("pms:accountManage:all")) {

        } else if (this.permissionCheck("pms:accountManage:dept")) {
            params.createUserDeptIds = [window.top.currentUser.defaultInfo.dept.id];  //部门权限
        } else {
            params.createBy = window.top.currentUser.id;  //个人权限
        }
        params.mediaCodes = mediaCodes;
        this.Actions.mediaStatusNum(params, (data) => {
            if (data) {
                this.setState({
                    logout: data.cancelRecordCount,
                    increased: data.createCount,
                    delete: data.deleteCount,
                    registered: data.recordedCount,
                    checking: data.recordingCount,
                    update: data.updateCount,
                })
            }
        })
    }

    //点击最新文章标题
    itemClick(record) {
        if (record.link) {
            utils.openNewWindow(record.link);
        } else {
            message.error("无法查看详情");
        }
    }

    //点击危险文章标题
    itemDangerClick(record) {
        let sensitiveWord = '';
        record.sensitiveWordList && record.sensitiveWordList.length > 0 && record.sensitiveWordList.forEach((item, i) => {
            sensitiveWord = sensitiveWord + item.oldStr + (i === record.sensitiveWordList.length - 1 ? '' : '、')
        });
        let signWords = sensitiveWord.split('、');
        let type = record.mediaType;
        if (type === 2) {
            //微信预览
            if (record && record.resourceId) {
                this.Actions.getWechatDangerDetails(record.resourceId, (data) => {
                    let _data = data;
                    if (_data) {
                        let parms = {
                            title: _data.title,
                            summary: _data.summary,
                            content: _data.content,
                            titlePic: _data.titlePic,
                            author: _data.author,
                            updateDate: new Date(_data.statDate),
                            url: _data.link,
                        };
                        this.WeChatReview.show('', '', signWords, parms)
                    } else {
                        message.error("该条数据已被删除,无法查看详情");
                    }

                });
            }

        } else if (type === 3) {
            //微博预览
            this.Actions.getWeiBoDangerDetails(record.resourceId, (data) => {
                let _data = data;
                if (_data) {
                    let reviewParms = {
                        updateDate: utils.formatDate(_data.createdAt),//内容
                        content: _data.text,
                        picUrls: _data.picUrls,
                        publishUrl: _data.shareUrl
                    };
                    this.MicroBlogReview.show(reviewParms, signWords)
                } else {
                    message.error("该条数据已被删除,无法查看详情");
                }

            });
        } else if (type === 5) {
            //抖音预览
            this.Actions.getDouyinDangerDetails(record.resourceId, (data) => {
                let _data = data;
                if (_data) {
                    let reviewParms = {
                        title: _data.title,
                        titlePic: _data.cover,
                        updateDate: _data.collecTime,
                        author: _data.author,
                        videoUrl: _data.videoUrl,
                        videoShareUrl: _data.shareUrl
                    };
                    this.TiktokReview.show(reviewParms, signWords)
                } else {
                    message.error("该条数据已被删除,无法查看详情");
                }
            });
        }
    }


    //获取最新文章
    getqueryLatestMaterial(mediaCodes) {
        let params = {
            count: 5
        };
        params.mediaCodes = mediaCodes;
        this.Actions.queryLatestMaterial(params, (data) => {
            if (data && data.length > 0) {
                this.setState({
                    newArticle: data
                })
            }
        })
    }

    //获取危险内容
    getSystemSensitiveCheckListQuery(mediaCodes) {
        let body = {
            page: 0,
            size: 5,
        };
        body.mediaCodes = mediaCodes;
        this.Actions.getSystemSensitiveCheckListQuery(body, (data) => {
            let _data = data && data.data;
            let systemSensitiveList = [];
            if (_data && _data.content && _data.content.length) {
                systemSensitiveList = _data.content;
            }
            this.setState({
                systemSensitiveList
            })
        })
    }


    //点击了最新文章more
    newArticleMore() {
        this.props.history.push('/view/newMediaMatrix/pms/contenManagement')
    }


    //点击了危险内容的more
    dangerContentMored() {
        this.props.history.push('/view/newMediaMatrix/pms/contentSecurityManagement')
    }

}
